document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelectorAll('.product-specs-comparison');

    if (section.length > 0) {
        section.forEach((sectionItem) => {
            // 获取自动轮播延迟时间，默认为5000ms
            const autoplayDelay = parseInt(sectionItem.dataset.autoplayDelay) || 5000;
            
            // DOM元素
            const stickyWrapper = sectionItem.querySelector('.sticky-animation-wrapper');
            let productImage = sectionItem.querySelectorAll('.product-specs-comparison-product-image');
            const thumbnailContainer = sectionItem.querySelector('.product-specs-thumbnail-container');
            
            stickyWrapper.classList.remove('sticky');

            // 状态变量
            const slidesCache = {
                header: [],
                content: []
            };

            let headerSwiper = null;
            let contentSwiper = null;
            let mm = null;
            let mobileAnimation = null;
            let desktopAnimation = null;
            
            // 进度条相关变量
            let progressAnimationId = null;
            let progressStartTime = 0;
            let isProgressRunning = false;

            // 初始化所有功能
            const initAll = () => {
                cleanup();
                initSwipers();
                handleThumbnails();
                productImage = sectionItem.querySelectorAll('.product-specs-comparison-product-image');
                initGSAPAnimations();
            };

            // 清理资源
            const cleanup = () => {
                if (mm) mm.revert();
                if (mobileAnimation) mobileAnimation.kill();
                if (desktopAnimation) desktopAnimation.kill();
                clearProgressIndicator();
            };

            // 初始化Swiper
            const initSwipers = () => {
                if (headerSwiper) headerSwiper.destroy(true, true);
                if (contentSwiper) contentSwiper.destroy(true, true);

                const headerSlides = sectionItem.querySelectorAll('.product-specs-comparison-header-swiper .swiper-slide');
                const contentSlides = sectionItem.querySelectorAll('.product-specs-comparison-content-swiper .swiper-slide');
                
                const isMobile = window.innerWidth < 768;
                const slidesPerView = isMobile ? 2 : 3;
                const shouldShowNav = headerSlides.length > slidesPerView;

                // 控制导航按钮和分页器的显示
                const navElements = sectionItem.querySelectorAll('.swiper-button-next, .swiper-button-prev, .product-specs-comparison-header-swiper-pagination');
                navElements.forEach(el => el.style.display = shouldShowNav ? '' : 'none');

                const commonSwiperConfig = {
                    direction: 'horizontal',
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    allowTouchMove: false,
                    noSwiping: true,
                    freeMode: false,
                    resistanceRatio: 0,
                    breakpoints: {
                        390: { slidesPerView: '2' },
                        768: {
                            slidesPerView: '3',
                            loop: shouldShowNav, // 只有幻灯片足够时才启用循环
                            
                            // autoplay: {
                            //     delay: autoplayDelay,
                            //     disableOnInteraction: false,
                            //     pauseOnMouseEnter: true
                            // },
                            // loopAdditionalSlides: 1,
                            // loopedSlides: 3
                        },
                    },
                };

                headerSwiper = new Swiper('.product-specs-comparison-header-swiper', {
                    ...commonSwiperConfig,
                    navigation: shouldShowNav ? {
                        nextEl: '.spec-fix-header .swiper-button-next',
                        prevEl: '.spec-fix-header .swiper-button-prev',
                    } : false,
                    pagination: shouldShowNav ? {
                        el: '.product-specs-comparison-header-swiper-pagination',
                        clickable: true,
                    } : false,
                    watchSlidesProgress: true,
                    on: {
                        init: function() {
                            slidesCache.header = Array.from(this.slides);
                            // if (window.innerWidth >= 768) {
                            //     this.autoplay.start();
                            //     initProgressIndicator();
                            // }
                        },
                        // resize: function() {
                        //     if (window.innerWidth >= 768) {
                        //         this.autoplay.start();
                        //         initProgressIndicator();
                        //     } else {
                        //         this.autoplay.stop();
                        //         clearProgressIndicator();
                        //     }
                        // },
                        // slideChange: function() {
                        //     initProgressIndicator();
                        // },
                        // autoplayStart: function() {
                        //     if (!isProgressRunning) {
                        //         initProgressIndicator();
                        //     }
                        // },
                        // autoplayStop: function() {
                        //     clearProgressIndicator();
                        // }
                    }
                });

                contentSwiper = new Swiper('.product-specs-comparison-content-swiper', {
                    ...commonSwiperConfig,
                    controller: { control: headerSwiper },
                    on: {
                        init: function() {
                            slidesCache.content = Array.from(this.slides);
                        }
                    }
                });

                headerSwiper.controller.control = contentSwiper;
            };

            // 进度条功能
            const initProgressIndicator = () => {
                const progressIndicator = document.getElementById('progressIndicator');
                if (!progressIndicator) return;
                
                clearProgressIndicator();
                
                progressIndicator.style.strokeDashoffset = '210';
                progressStartTime = performance.now();
                isProgressRunning = true;
                
                const animateProgress = (timestamp) => {
                    if (!progressStartTime) progressStartTime = timestamp;
                    const elapsed = timestamp - progressStartTime;
                    const progress = Math.min(elapsed / autoplayDelay, 1);
                    
                    // 更新进度条
                    progressIndicator.style.strokeDashoffset = 210 * (1 - progress);

                    // 继续动画直到完成
                    if (progress < 1) {
                        progressAnimationId = requestAnimationFrame(animateProgress);
                    }
                };
                
                progressAnimationId = requestAnimationFrame(animateProgress);
            };

            const clearProgressIndicator = () => {
                if (progressAnimationId) {
                    cancelAnimationFrame(progressAnimationId);
                    progressAnimationId = null;
                }
                isProgressRunning = false;
                progressStartTime = 0;
            };

            // 移动端缩略图处理
            const handleThumbnails = () => {
                if (window.innerWidth >= 768) {
                    if (thumbnailContainer) thumbnailContainer.style.display = 'none';
                    return;
                }

                if (thumbnailContainer) {
                    thumbnailContainer.style.display = '';
                    
                    const thumbnailItems = thumbnailContainer.querySelectorAll('.product-specs-thumbnail-item');
                    const prevButton = thumbnailContainer.querySelector('.product-specs-thumbnail-button-prev');
                    const nextButton = thumbnailContainer.querySelector('.product-specs-thumbnail-button-next');
                    
                    let selectedIndexes = [0, 1];
                            
                    const reorderSlides = () => {
                        try {
                            const headerWrapper = headerSwiper.el.querySelector('.swiper-wrapper');
                            const contentWrapper = contentSwiper.el.querySelector('.swiper-wrapper');
                            
                            headerWrapper.innerHTML = '';
                            contentWrapper.innerHTML = '';

                            let sortSelectedIndexes = [...selectedIndexes].sort((a, b) => a - b);

                            sortSelectedIndexes.forEach(index => {
                                if (slidesCache.header[index] && slidesCache.content[index]) {
                                    headerWrapper.appendChild(slidesCache.header[index].cloneNode(true));
                                    contentWrapper.appendChild(slidesCache.content[index].cloneNode(true));
                                }
                            });
                            
                            slidesCache.header.forEach((slide, index) => {
                                if (!sortSelectedIndexes.includes(index) && slidesCache.content[index]) {
                                    headerWrapper.appendChild(slide.cloneNode(true));
                                    contentWrapper.appendChild(slidesCache.content[index].cloneNode(true));
                                }
                            });
                            
                            headerSwiper.update();
                            contentSwiper.update();
                        } catch (error) {
                            console.error('Reorder error:', error);
                        }
                    };

                    const updateActiveThumbnails = () => {
                        thumbnailItems.forEach((item, index) => {
                            item.classList.toggle('active', selectedIndexes.includes(index));
                        });
                    };

                    setTimeout(() => {
                        updateActiveThumbnails();
                        reorderSlides();
                    }, 100);

                    thumbnailItems.forEach((item, index) => {
                        item.addEventListener('click', () => {
                            if (selectedIndexes.includes(index)) return;
                            selectedIndexes = [selectedIndexes[1], index];
                            updateActiveThumbnails();
                            reorderSlides();
                        });
                    });

                    prevButton.addEventListener('click', () => {
                        selectedIndexes = selectedIndexes.map(index => 
                            (index - 1 + thumbnailItems.length) % thumbnailItems.length
                        );
                        updateActiveThumbnails();
                        reorderSlides();
                    });

                    nextButton.addEventListener('click', () => {
                        selectedIndexes = selectedIndexes.map(index => 
                            (index + 1) % thumbnailItems.length
                        );
                        updateActiveThumbnails();
                        reorderSlides();
                    });
                }
            };

            // GSAP动画初始化
            const initGSAPAnimations = () => {
                gsap.registerPlugin(ScrollTrigger);
                
                mm = gsap.matchMedia();
                
                // 移动端动画
                mm.add('(max-width: 768px)', () => {
                    mobileAnimation = gsap.to(productImage, {
                        scrollTrigger: {
                            trigger: stickyWrapper,
                            start: 'top-=100 top',
                            end: 'top-=60 top',
                            scrub: true,
                            markers: false,
                            onLeave: () => stickyWrapper.classList.add('sticky'),
                            onEnterBack: () => stickyWrapper.classList.remove('sticky')
                        }
                    });
                });

                // 桌面端动画
                mm.add('(min-width: 769px)', () => {
                    desktopAnimation = gsap.to(productImage, {
                        width: '130px',
                        height: '110px',
                        scrollTrigger: {
                            trigger: stickyWrapper,
                            start: 'top-=220 top',
                            end: 'top-=106 top',
                            scrub: true,
                            onLeave: () => stickyWrapper.classList.add('sticky'),
                            onEnterBack: () => stickyWrapper.classList.remove('sticky')
                        }
                    });
                });
            };

            // 初始加载
            initAll();

            // 窗口resize事件处理
            let resizeTimeout;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    initAll();
                }, 250);
            });
        });
    }
});
